{
  "journalAudit.action.dependency.answered": "Réponse à une dépendance demandée"
}
